export const IT_VERTICALS = [
  'DEVELOPMENT',
  'PRODUCT_DESIGN',
  'TECHNICAL_MARKETING',
  'TECHNICAL_WRITING',
  'TECH_CONSULTING',
] as const;
export type ITVertical = (typeof IT_VERTICALS)[number];

export const IT_VERTICAL_LABEL: Record<ITVertical, string> = {
  DEVELOPMENT: 'Développement (web, mobile, backend, fullstack, devops, data, IA)',
  PRODUCT_DESIGN: 'Design produit / UX-UI',
  TECHNICAL_MARKETING: 'Marketing technique (SEO, ads, growth, automation, no-code)',
  TECHNICAL_WRITING: 'Rédaction technique et copywriting digital',
  TECH_CONSULTING: 'Conseil tech / architecture / audit',
};

export const IT_VERTICAL_SHORT_LABEL: Record<ITVertical, string> = {
  DEVELOPMENT: 'Développement',
  PRODUCT_DESIGN: 'Design produit',
  TECHNICAL_MARKETING: 'Marketing technique',
  TECHNICAL_WRITING: 'Rédaction technique',
  TECH_CONSULTING: 'Conseil tech',
};

export const QUOTE_MODES = ['TIME_BASED_DAY', 'TIME_BASED_HOUR', 'PER_LINE', 'FIXED'] as const;
export type QuoteMode = (typeof QUOTE_MODES)[number];

export const DISCREPANCY_TYPES = ['NONE', 'ADDITION', 'MODIFICATION', 'DELETION_PROPOSED'] as const;
export type DiscrepancyType = (typeof DISCREPANCY_TYPES)[number];
